<template>
	<v-row no-gutters>

		<v-col cols='12' class='pb-3'>
			<h1 id='headline' v-if="$store.pagination.total">
				Unsere Partner bieten 
				<span class='accent--text'>{{ $store.pagination.total }} Fahrzeuge</span>
				für Dich im Abo an
			</h1>
		</v-col>

		<v-col id='filter-chips' cols='12'>
			<filter-chips />
		</v-col>

		<v-col cols='3'>
			<v-row no-gutters>
				<filter-list />
				<option-list />
			</v-row>
		</v-col>

		<v-col class='pl-6' cols='9'>

			<catalog-banner-carousel />

			<v-row align='center' dense style='margin-bottom: 2px; padding: 0 1px'>
				<v-col class='green--text font-weight-bold d-inline-flex flex-nowrap align-center' style='font-size: 13px'
					cols='7'>
					<v-icon size='13.2' color='green' style='margin-bottom: 0.35px; margin-left: 1px'>
						fas fa-check-circle
					</v-icon>
					<div class='ml-1' style='font-size: 12px'>
						All-Inclusive Preis: Alle Kosten rund um's Auto inklusive, bis auf Sprit!
					</div>
				</v-col>
				<v-col class='flex-grow-0 d-inline-flex flex-nowrap align-center' cols='3'>
					<div style='min-width: 74px; font-size: 13px' class='font-weight-bold'>
						Sortieren:
					</div>
					<select-component v-model='$store.sortBy' :height='34' class='light-input' :options='$store.sortByItems'
						dense title='Sortieren nach:' width='170px' />
				</v-col>
				<v-col cols='2' class='d-inline-flex flex-nowrap pl-3'>
					<div style='font-size: 13px' class='font-weight-bold'>
						Ansicht:
					</div>
					<v-icon class='clickable-icon ml-3' size='16' :color='color.galleryColor' @click='toggleGallery'>
						fa fa-th
					</v-icon>
					<v-icon class='ml-2 clickable-icon' size='16' :color='color.listColor' @click='toggleList'>
						far fa-list
					</v-icon>
				</v-col>
			</v-row>

			<VehiclesList :is-list='isList' />
		</v-col>
	</v-row>
</template>

<script>
import FilterList from '@/components/FilterList'
import OptionList from '@/components/OptionList'
import VehiclesList from '@/components/VehiclesList'
import SelectComponent from '@/components/SelectComponent'
import FilterChips from './FilterChips'
import CatalogBannerCarousel from './KatalogBanner/CatalogBannerCarousel';

export default {
	name: 'CatalogDesktop',
	components: {
		CatalogBannerCarousel,
		FilterChips,
		SelectComponent,
		VehiclesList,
		FilterList,
		OptionList
	},
	data() {
		return {
			isList: true,
			utmSources: [
				"mivodo.com",
				"goleasy.de",
				"abofahren-en",
				"partner",
				"as24.de / web",
				"digital-affin-en",
				"autoabos-org",
				"autobild.de",
				"mobile.de"
			],
			utmMediums: ["cpc"]
		}
	},
	computed: {
		color() {
			if (this.isList) {
				return {
					galleryColor: 'grey',
					listColor: 'black'
				}
			} else {
				return {
					galleryColor: 'black',
					listColor: 'grey'
				}
			}
		}
	},
	methods: {
		toggleGallery() {
			this.isList = false
		},

		toggleList() {
			this.isList = true
		},

		setDisturberCookie() {
			const expirationDate = new Date();
			expirationDate.setMonth(expirationDate.getMonth() + 3);
			document.cookie = `disturber=1; expires=${expirationDate.toUTCString()}`;
		}
	},
	mounted() {
		// Get the query params part of the url
		const queryParams = window.location.search;

		/**
		 * Check if any of the utm sources is included in the url parameters
		 * If yes then set the disturber cookie to 1
		 * so that the banner does not appear for the specific utm params. 
		*/
		if (
			(queryParams.includes("utm_source=google") && this.utmMediums.some(parameter => queryParams.includes(`utm_medium=${parameter}`))) ||
			this.utmSources.some(parameter => queryParams.includes(`utm_source=${parameter}`))
		) {
			this.setDisturberCookie();
		}
	}
}
</script>

<style lang='scss' scoped>
#headline {
	font-size: 30px;
	font-weight: bold;
}

.clickable-icon {
	&:hover {
		cursor: pointer;
	}
}
</style>
